export default __webpack_public_path__ + "static/img10-0da3a61a12ddea1a708d2f01e77dfc32.webp";